function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react'; // author: Aidan L.

import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import { TYPE_BUTTON } from './constants';
import Button from './Button';

var getTogglableValue = function getTogglableValue(pressedState, defaultValue, alternateValue) {
  var value = defaultValue;

  if (pressedState && alternateValue) {
    value = alternateValue;
  }

  return value;
};

var getAriaPressedAttribute = function getAriaPressedAttribute(isPressed, childrenAlt) {
  var attribute; // Sets the aria-pressed attribute in the absense of alternate children

  if (!childrenAlt) {
    attribute = isPressed;
  } // For instances where we pass in children and childrenAlt
  // Do not include aria-pressed attribute


  return attribute;
};

var ToggleButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ToggleButton, _React$PureComponent);

  function ToggleButton(props) {
    var _this;

    _classCallCheck(this, ToggleButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleButton).call(this, props));
    var isPressed = props.isPressed;
    _this.state = {
      isPressed: isPressed
    };
    return _this;
  }

  _createClass(ToggleButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var nextIsPressed = _ref.isPressed;

      if (nextIsPressed === this.props.isPressed) {
        return;
      }

      this.setState({
        isPressed: nextIsPressed
      });
    }
  }, {
    key: "_handlePress",
    value: function _handlePress() {
      var isPressed = this.state.isPressed;
      var onPress = this.props.onPress;
      this.setState({
        isPressed: !isPressed
      });

      if (onPress) {
        onPress(!isPressed);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          childrenAlt = _this$props.childrenAlt,
          ariaLabel = _this$props.ariaLabel,
          childrenAltAriaLabel = _this$props.childrenAltAriaLabel;
      var isPressed = this.state.isPressed;
      var buttonProps = pick.apply(void 0, [this.props].concat(_toConsumableArray(Object.keys(Button.propTypes))));
      var className = classNames('eds-btn-toggle', {
        'eds-btn-toggle--is-pressed': isPressed
      });
      var buttonBody = getTogglableValue(isPressed, children, childrenAlt);
      return React.createElement("div", {
        className: className,
        "data-spec": "eds-btn-toggle"
      }, React.createElement(Button, _extends({}, buttonProps, {
        type: TYPE_BUTTON,
        "aria-pressed": getAriaPressedAttribute(isPressed, childrenAlt),
        "aria-label": getTogglableValue(isPressed, ariaLabel, childrenAltAriaLabel),
        onClick: this._handlePress.bind(this)
      }), buttonBody));
    }
  }]);

  return ToggleButton;
}(React.PureComponent);

_defineProperty(ToggleButton, "propTypes", _objectSpread({}, Button.propTypes, {
  /**
   * Required
   * Provides the default content of the button
   */
  children: PropTypes.node.isRequired,

  /**
   * Aria-label which corresponds to children for use in cases
   * where a text label is not visible on the screen
   */
  ariaLabel: EBPropTypes.translation,

  /**
   * Default for whether or not button is pressed
   */
  isPressed: PropTypes.bool,

  /**
   * Callback function invoked when the button is pressed
   * (isPressed) => { }
   */
  onPress: PropTypes.func,

  /**
   * Optional
   * Provides a second child for alternating pressed states
   * For use as a button whose contents change when pressed
   * An example would be a play/pause button on a video player
   * childrenAlt could be some text or an icon
   */
  childrenAlt: PropTypes.node,

  /**
   * Optional
   * Aria-label which corresponds to childrenAlt for use in cases
   * where a text label is not visible on the screen
   */
  childrenAltAriaLabel: EBPropTypes.translation
}));

_defineProperty(ToggleButton, "defaultProps", {
  isPressed: false
});

export { ToggleButton as default };